// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CurrentInternalUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentInternalUserQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string, user: { __typename?: 'User', id: string, isBeingImpersonated: boolean } } | null | undefined };

export type StopInternalUserImpersonationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StopInternalUserImpersonationMutation = { __typename?: 'Mutation', saveInternalUser: { __typename?: 'SaveInternalUserResult', internalUser: { __typename?: 'InternalUser', id: string, user: { __typename?: 'User', id: string, isBeingImpersonated: boolean } } } };


export const CurrentInternalUserDocument = gql`
    query CurrentInternalUser {
  currentInternalUser {
    id
    name
    email
    avatar
    user {
      id
      isBeingImpersonated
    }
  }
}
    `;

/**
 * __useCurrentInternalUserQuery__
 *
 * To run a query within a React component, call `useCurrentInternalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentInternalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentInternalUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentInternalUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
      }
export function useCurrentInternalUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
        }
// @ts-ignore
export function useCurrentInternalUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>;
export function useCurrentInternalUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentInternalUserQuery | undefined, CurrentInternalUserQueryVariables>;
export function useCurrentInternalUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
        }
export type CurrentInternalUserQueryHookResult = ReturnType<typeof useCurrentInternalUserQuery>;
export type CurrentInternalUserLazyQueryHookResult = ReturnType<typeof useCurrentInternalUserLazyQuery>;
export type CurrentInternalUserSuspenseQueryHookResult = ReturnType<typeof useCurrentInternalUserSuspenseQuery>;
export type CurrentInternalUserQueryResult = ApolloReactCommon.QueryResult<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>;
export const StopInternalUserImpersonationDocument = gql`
    mutation StopInternalUserImpersonation {
  saveInternalUser(input: {impersonateInternalUserId: null}) {
    internalUser {
      id
      user {
        id
        isBeingImpersonated
      }
    }
  }
}
    `;

/**
 * __useStopInternalUserImpersonationMutation__
 *
 * To run a mutation, you first call `useStopInternalUserImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopInternalUserImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopInternalUserImpersonationMutation, { data, loading, error }] = useStopInternalUserImpersonationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopInternalUserImpersonationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopInternalUserImpersonationMutation, StopInternalUserImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopInternalUserImpersonationMutation, StopInternalUserImpersonationMutationVariables>(StopInternalUserImpersonationDocument, options);
      }
export type StopInternalUserImpersonationMutationHookResult = ReturnType<typeof useStopInternalUserImpersonationMutation>;
export type StopInternalUserImpersonationMutationResult = ApolloReactCommon.MutationResult<StopInternalUserImpersonationMutation>;